import React from "react";
import { useLoaderData } from "react-router-dom";
import { GET_COLLECTION } from "../hooks/useInventory";
import Four0Four from "./404";
import { Tile } from "../components/views";
import { useQuery } from "@apollo/client";
import Pagination from "../components/pagination";
import URI from "urijs";
import { getImageForFormat } from "../utils";
import useResponsive from "../hooks/useResponsive";

const Collection = ({ id }) => {
  const { data: { id: idFromLoader } } = useLoaderData();
  const { isMobile } = useResponsive();
  const currentUri = new URI(location.pathname + location.search);
  const search = currentUri.search(true);
  const currentPage = parseInt(search.page) || 1;
  const { data, loading } = useQuery(GET_COLLECTION, { variables: { id: id || idFromLoader, page: currentPage } });

  if (loading) return null;
  else if (!data?.collection) return <Four0Four />;

  const { collection, page } = data.collection;

  return (
    <div id="collection">
      <div className="header">
        <h1>{collection.title}</h1>
        {collection?.banner?.media ? <div className="banner">
          <img src={getImageForFormat(collection.banner.media, isMobile ? "small" : "banner-free-ratio")} />
        </div> : null }
        {collection?.description ? <div className="description">
        <div dangerouslySetInnerHTML={{ __html: collection.description?.content }} />
      </div> : null }
      </div>
      <div className="entries">
        {page.items.map(e => (<Tile key={e.id} item={e} />))}
      </div>
      <Pagination pagination={page.pagination} currentUri={currentUri} />
    </div>
  );
};

const Loader = async props => {
  return { data: { id: parseInt(props.params.id) } };
};

const Routes = (homepage) => {
  const routes = [{
    path: "/collection/:id/:slug",
    element: <Collection />,
    loader: Loader
  }];
  if (homepage?.type === "collection") {
    const uri = new URI(homepage?.handle);
    routes.push({
      path: "/",
      element: <Collection id={parseInt(uri.segment(1))} />,
      loader: Loader
    });
  }
  return routes;
};

export default Collection;
export { Routes };
